<template>
  <el-dialog class="dialog-container" @close="handleClose" title="绑定实体卡" :visible.sync="dialogVisible">
    <div class="dialog-search-btn">
      <el-input v-model="value" clearable placeholder="请输入用户ID/手机号"></el-input>
      <el-button type="primary" icon="el-icon-search" @click="clickSearch" size="medium">查询</el-button>
    </div>
    <template v-if="isShowInfo">
      <el-divider content-position="left">会员信息</el-divider>
      <span v-if="memberInfo.name !==''" style="margin-left:85px;" class="span-divider">姓名：{{memberInfo.name}}</span>
      <span v-else style="margin-left:85px;" class="span-divider">姓名：{{memberInfo.wxname}}</span>
      <span class="span-divider">ID：{{memberInfo.mid}}</span>
      <span class="span-divider">手机号：{{memberInfo.mobile}}</span>
    </template>
    <span slot="footer" class="dialog-footer">
      <el-checkbox v-if="isShowInfo" style="margin-right:20px;" v-model="checked">确认会员信息</el-checkbox>
      <el-button type="primary" :disabled="!checked" @click="handleAffirm">绑 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { memberAddCard } from '@/views/webpc/CashierDesk/CardManagementApp/apis'
import { searchMemberInfo } from '@/views/webpc/CashierDesk/CashRechargeApp/apis'
export default {
  data () {
    return {
      value: '',
      checked: false,
      memberInfo: {},
      isShowInfo: false,
      dialogVisible: false
    }
  },
  methods: {
    show () {
      this.dialogVisible = true
    },
    // 绑定实体卡
    getHandleMemberAddCard (cardno) {
      let data = new FormData()
      data.append('mid', this.memberInfo.mid)
      data.append('cardno', cardno)
      memberAddCard(data)
        .then(result => {
          if (result) {
            this.$emit('ok')
            this.dialogVisible = false
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
          }
        })
    },
    // 绑定实体卡触发
    handleAffirm () {
      this.$prompt('请输入实体卡号', '实体卡号', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[0-9a-zA-Z]+$/,
        inputErrorMessage: '卡号格式不正确'
      }).then(({ value }) => {
        this.getHandleMemberAddCard(value)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        })
      })
    },
    // 查询用户
    clickSearch () {
      this.memberInfo = {}
      this.isShowInfo = false
      this.checked = false
      if (this.value === '') {
        this.$message({
          type: 'warning',
          message: '请输入用户ID/手机号'
        })
        return
      }
      let data = new FormData()
      data.append('keywords', this.value)
      searchMemberInfo(data)
        .then(result => {
          if (result) {
            if (result.data) {
              this.isShowInfo = true
              this.memberInfo = result.data
            } else {
              this.$confirm('查无数据，请确认输入信息是否正确！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
              }).catch(() => {
              })
            }
          }
        })
    },
    handleClose () {
      this.value = ''
      this.checked = false
      this.memberInfo = {}
      this.isShowInfo = false
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/webpc/CashierDesk/CardManagementApp/modules/CardModal.vue